module.exports = __webpack_public_path__ + "img/contribution.dfb26b99.svg";